import { imageZoom } from "../../utils/image-zoom";
export function mySubscriptions(products) {
    return {
        products,
        imageZoom: imageZoom(),
    };
}
